module.exports = __webpack_public_path__ + "img/Hierkonpolku_DSC_9195_Terhi Ajosenpää_800px.2aebddbc.jpg";